module.exports = __webpack_public_path__ + "img/ico-dollar.953cd46e.svg";